import React from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import ClaimCard from './pages/ClaimCard';
import HomePage from './pages/HomePage.jsx';
import CardRedeemed from './components/CardRedeemed';
// import CollectionIncomplete from './pages/CollectionIncomplete';
// import CollectionComplete from './pages/CollectionComplete';
import Collection from './pages/Collection';
import ScrollToTop from './components/ScrollToTop';
import { AppProvider } from './AppContext';
import { SDKProvider } from './context/sdk/provider';
import { Web3DevHubProvider } from './context/devhub/Web3DevHubContext';
import ProtectedRoute from './components/ProtectedRoute';
// import AuthRedirectPage from './components/AuthRedirectPage';
import AuthCallback from './components/AuthCallback';
import { ROUTES } from './routes/routeConstants';
import { UserProfileProvider } from './context/user/UserProfileContext';

function App() {

  return (
    <AppProvider>
      <SDKProvider>
        <UserProfileProvider>
          <Web3DevHubProvider>
            <Router>
              <ScrollToTop />
              <Routes>
                <Route path={ROUTES.ROOT} element={<HomePage/>}/>

                {/* Auth Routes */}
                <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallback fallbackComponent={<HomePage />}/>}/>
                {/* <Route path={ROUTES.AUTH_REDIRECT} element={<AuthRedirectPage />}/> */}

                <Route path="/how-to-train-your-dragon" element={<HomePage/>}/>

                  {/* Private Routes for authenticated users */}
                <Route path="/how-to-train-your-dragon/claim-card" 
                  element={
                  <ProtectedRoute>
                    <ClaimCard/>
                  </ProtectedRoute>
                  }/>

                <Route path="/how-to-train-your-dragon/collection" 
                  element={
                  <ProtectedRoute>
                    <Collection/>
                  </ProtectedRoute>
                  }/>

                <Route path="*" element={<Navigate to="/how-to-train-your-dragon" />} />
              </Routes>
            </Router>
          </Web3DevHubProvider>
        </UserProfileProvider>
      </SDKProvider>
    </AppProvider>
  );
}

export default App;
